<ew-mat-dialog-custom
  class="overflow-hidden grid grid-rows-[1fr_1px_auto] h-full">
  <div class="mx-10 mt-8">
    <h1>{{ 'settingsUsers:removeUser' | translate }}</h1>

    <div class="my-6">
      <p>
        <b>{{ userEmail }}</b>
        {{ 'settingsUsers:removeUserMessage' | translate }}
      </p>
    </div>
  </div>

  <hr class="w-full m-0 mt-10" />

  <div class="mx-10 py-4 grid grid-cols-[1fr_auto_auto] gap-4">
    <div></div>
    <button
      mat-stroked-button
      class="rounded-lg xs:w-full w-20"
      color="secondary"
      [disabled]="loading"
      (click)="dialogRef.close()">
      {{ 'shared:cancel' | translate }}
    </button>

    <button
      mat-flat-button
      class="rounded-lg xs:w-full w-40"
      color="warn"
      [disabled]="loading"
      (click)="deactivateUser()">
      <span *ngIf="!loading">{{
        'settingsUsers:removeUserButton' | translate
      }}</span>
      <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
    </button>
  </div>
</ew-mat-dialog-custom>
